module.exports = __webpack_public_path__ + "img/booking.58948a1e.webp";